import React, { useContext } from 'react'
import PresentationContext from './presentation-context'

const withPresentation = Component => props => (
  <PresentationContext.Consumer>
    {value => <Component {...value} {...props} />}
  </PresentationContext.Consumer>
)

const usePresentation = () => {
  return useContext(PresentationContext)
}

export { withPresentation, usePresentation }
